/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Download_Digital_BookInputs */

const en_download_digital_book = /** @type {(inputs: Download_Digital_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download Digital Book (.epub)`)
};

const es_download_digital_book = /** @type {(inputs: Download_Digital_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descargar Libro Digital (.epub)`)
};

const fr_download_digital_book = /** @type {(inputs: Download_Digital_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Télécharger le Livre Numérique (.epub)`)
};

const de_download_digital_book = /** @type {(inputs: Download_Digital_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digitales Buch herunterladen (.epub)`)
};

const ja_download_digital_book = /** @type {(inputs: Download_Digital_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デジタルブックをダウンロード (.epub)`)
};

const zh_download_digital_book = /** @type {(inputs: Download_Digital_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下载电子书 (.epub)`)
};

const ar_download_digital_book = /** @type {(inputs: Download_Digital_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تنزيل الكتاب الرقمي (.epub)`)
};

const id_download_digital_book = /** @type {(inputs: Download_Digital_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unduh Buku Digital (.epub)`)
};

const it_download_digital_book = /** @type {(inputs: Download_Digital_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scarica Libro Digitale (.epub)`)
};

const ru_download_digital_book = /** @type {(inputs: Download_Digital_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скачать Цифровую Книгу (.epub)`)
};

const pt_download_digital_book = /** @type {(inputs: Download_Digital_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descarregar Livro Digital (.epub)`)
};

const ko_download_digital_book = /** @type {(inputs: Download_Digital_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`디지털 책 다운로드 (.epub)`)
};

/**
* | output |
* | --- |
* | "Download Digital Book (.epub)" |
*
* @param {Download_Digital_BookInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const download_digital_book = /** @type {((inputs?: Download_Digital_BookInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Download_Digital_BookInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_download_digital_book(inputs)
	if (locale === "es") return es_download_digital_book(inputs)
	if (locale === "fr") return fr_download_digital_book(inputs)
	if (locale === "de") return de_download_digital_book(inputs)
	if (locale === "ja") return ja_download_digital_book(inputs)
	if (locale === "zh") return zh_download_digital_book(inputs)
	if (locale === "ar") return ar_download_digital_book(inputs)
	if (locale === "id") return id_download_digital_book(inputs)
	if (locale === "it") return it_download_digital_book(inputs)
	if (locale === "ru") return ru_download_digital_book(inputs)
	if (locale === "pt") return pt_download_digital_book(inputs)
	return ko_download_digital_book(inputs)
});